<template>
  <div
    ref="root"
    class="dropdown b-dropdown"
    :class="[$attrs.class, { show: open }]"
  >
    <button
      type="button"
      class="btn btn-secondary dropdown-toggle"
      aria-haspopup="true"
      :aria-expanded="open ? 'true' : 'false'"
      @click.stop="toggle"
    />
    <div
      class="dropdown-menu"
      :class="{ show: open, 'dropdown-menu-right': right }"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BDropdown',
  inheritAttrs: false,
  props: {
    text: { type: String, default: 'Options' },
    right: { type: Boolean, default: false }
  },
  data () {
    return { open: false }
  },
  provide () {
    return {
      closeBDropdown: this.close
    }
  },
  mounted () {
    document.addEventListener('click', this.onDocumentClick)
  },
  beforeUnmount () {
    document.removeEventListener('click', this.onDocumentClick)
  },
  methods: {
    toggle () {
      this.open = !this.open
    },
    close () {
      this.open = false
    },
    onDocumentClick (event) {
      if (!this.open) return
      const root = this.$refs.root
      if (root && !root.contains(event.target)) {
        this.close()
      }
    }
  }
}
</script>
